import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetogoacabs() {



  const cardData =
  {
    keyword: 'Pune to Goa Cab',
    heading: 'Sai Trupti Cabs: Pune to Goa Cab',
    headingDescription: 'Sai Trupti Cabs offers reliable and comfortable Pune to Goa cab services, designed to make your out-station journey smooth and stress-free. Our fleet includes well-maintained, air-conditioned Sedans, SUVs, and Premium vehicles — all equipped with clean interiors and ample luggage space. Every journey is driven by a professional, background-verified chauffeur who ensures punctual pickup in Pune, courteous service, and safe, smooth driving all the way to Goa. With transparent one-way fares, flexible booking options (one-way or round-trip), and 24×7 customer support, Sai Trupti Cabs makes your travel from Pune to Goa convenient, affordable, and worry-free.',

    top: 'Top Places to Visit in Goa with Sai Trupti Cabs',

"topPlaces": [
  {
    "title": "Calangute Beach",
    "description": "Calangute Beach, famously known as the 'Queen of Beaches', is Goa’s most vibrant coastal stretch, drawing travelers from all over the world. Lined with lively shacks, water sports, and sunbathers, it’s the heart of North Goa’s energetic vibe. Visitors can enjoy parasailing, jet-skiing, and banana boat rides, or relax on beach loungers under the golden sun. As dusk falls, music drifts through the salty air and the beach transforms into a glowing carnival of lights and laughter. Calangute is not just a destination — it’s the spirit of Goa’s freedom, adventure, and beachside bliss."
  },
  {
    "title": "Basilica of Bom Jesus",
    "description": "The Basilica of Bom Jesus in Old Goa is one of India’s oldest churches and a UNESCO World Heritage Site, revered for housing the mortal remains of St. Francis Xavier. Built in 1605, its baroque architecture, gilded altars, and marble mosaic floors reflect Goa’s colonial grandeur. Inside, the air resonates with peace and history as visitors admire intricate carvings and sacred relics. The church stands as a timeless testament to Goa’s deep Christian heritage and artistic mastery. Every step within its walls connects travelers to faith, culture, and centuries of devotion."
  },
  {
    "title": "Dudhsagar Waterfalls",
    "description": "Dudhsagar Waterfalls, located on the Goa–Karnataka border, is one of India’s tallest and most magnificent cascades. The name ‘Dudhsagar’ translates to ‘Sea of Milk,’ perfectly describing the frothy white torrent that plunges from 310 meters amidst lush forests. The best time to visit is during monsoon, when the falls thunder in full glory, surrounded by mist and greenery. Jeep safaris, railway bridge viewpoints, and forest treks make the experience unforgettable. Dudhsagar captures the raw, untamed beauty of Goa beyond its beaches — where nature rules supreme."
  },
  {
    "title": "Anjuna Beach & Flea Market",
    "description": "Anjuna Beach is Goa’s bohemian soul — where music, art, and sea breeze merge into an unforgettable vibe. Known for its rocky shores and legendary full-moon parties, it attracts backpackers, artists, and free spirits. The famous Anjuna Flea Market, held weekly, offers handmade jewelry, clothes, antiques, and souvenirs from around the world. As the sun sets, the beach glows under neon lights while waves rhythmically crash nearby. With its carefree atmosphere and creative energy, Anjuna is where Goa’s hippie roots still live strong."
  },
  {
    "title": "Palolem Beach",
    "description": "Palolem Beach, located in South Goa, is a serene crescent-shaped paradise lined with swaying coconut palms and colorful huts. Its calm, shallow waters make it ideal for swimming and kayaking. Visitors can take dolphin-watching boat rides or simply lounge on the sands with a book in hand. By night, the beach transforms with its glowing ‘Silent Disco,’ where travelers groove under headsets to their favorite tunes. Peaceful yet lively, Palolem offers the perfect balance between relaxation and adventure — a haven for those seeking Goa’s soulful tranquility."
  },
  {
    "title": "Fort Aguada",
    "description": "Fort Aguada, perched on a cliff overlooking the Arabian Sea, is one of Goa’s most iconic historic landmarks. Built by the Portuguese in the 17th century to guard against invasions, it features an ancient lighthouse and sturdy ramparts. The panoramic views from the fort are breathtaking, especially at sunset. Visitors love exploring its tunnels, stone pathways, and the nearby SinQ Beach stretch. Fort Aguada’s timeless presence tells tales of Goa’s colonial past while offering a perfect backdrop for photography and coastal exploration."
  },
  {
    "title": "Chapora Fort",
    "description": "Chapora Fort, made famous by the Bollywood film 'Dil Chahta Hai', offers one of the most stunning viewpoints in Goa. Overlooking Vagator Beach, its ruins stand proudly against the backdrop of rolling waves and fiery sunsets. Visitors often trek up the hill to capture postcard-perfect views of the sea and cliffs below. Though only remnants of the fort remain, the panoramic charm and peaceful atmosphere make it a favorite for couples and photographers. Chapora Fort embodies Goa’s blend of nostalgia, adventure, and cinematic romance."
  },
  {
    "title": "Fontainhas Latin Quarter",
    "description": "Fontainhas, located in Panjim, is Goa’s colorful Latin Quarter where heritage meets art. Narrow winding streets, pastel-hued Portuguese houses, and ornate balconies create a postcard-perfect setting. Art galleries, cafés, and bakeries fill the air with culture and aroma. A walk through Fontainhas feels like traveling through a European town infused with Goan warmth. The area also houses historic churches and quaint boutique stays, making it a must-visit for culture lovers. It’s a vibrant celebration of Goa’s colonial charm and enduring creativity."
  },
  {
    "title": "Baga Beach",
    "description": "Baga Beach is the heartbeat of North Goa, where the fun never stops. Known for its thrilling water sports, bustling nightlife, and iconic beach clubs like Tito’s and Café Mambo, it offers something for everyone. Jet-skiing, parasailing, and banana rides keep the adrenaline flowing by day, while evenings explode with music, food, and dance. Baga’s lively vibe attracts travelers seeking energy and entertainment, yet its sunrise walks reveal a quieter, soothing side. It’s the perfect representation of Goa’s dynamic spirit — joyful, carefree, and endlessly exciting."
  },
  {
    "title": "Spice Plantations & Backwater Cruise",
    "description": "Goa’s spice plantations, tucked away near Ponda, showcase the state’s lush countryside and fragrant agricultural heritage. Visitors can explore estates filled with cardamom, pepper, vanilla, and betel nut trees, guided by locals who explain traditional farming methods. A typical visit ends with a delicious Goan lunch served on banana leaves. Nearby, the Mandovi backwater cruise offers tranquil boat rides through mangroves, where birds and fishermen animate the scene. This experience reveals Goa’s rural charm and earthy essence, far from the coast’s party energy — an authentic slice of tropical paradise."
  }
],



"services": [
    {
      "name": "Pune to Goa Cab",
      "description": "Book a comfortable cab from Pune to Goa for a smooth and relaxing journey. Available in AC and Non-AC options, with professional drivers, luggage support, and flexible pickup and drop locations. Ideal for family vacations, group trips, or corporate travel."
    },
    {
      "name": "Pune to Goa Taxi Service",
      "description": "Premium taxi service from Pune to Goa with well-maintained vehicles, including Innova and Ertiga. Perfect for outstation travel, one-way trips, and corporate bookings. Enjoy professional chauffeurs, punctual pickups, and online booking options for hassle-free travel."
    },
    {
      "name": "Pune to Goa Car Hire",
      "description": "Hire a car from Pune to Goa with AC and Non-AC options. Suitable for leisure, family trips, or business travel. Enjoy luggage assistance, professional driver service, flexible scheduling, and transparent pricing for a seamless journey."
    },
    {
      "name": "Pune to Goa AC Cab",
      "description": "Travel in comfort with AC cabs from Pune to Goa, ensuring a cool and relaxing ride. Perfect for long-distance trips, corporate travel, and family outings. Includes professional drivers, luggage support, and online booking for convenience."
    },
    {
      "name": "Pune to Goa Non AC Cab",
      "description": "Affordable Non-AC cab service from Pune to Goa for budget-conscious travelers. Well-maintained vehicles, professional drivers, luggage support, flexible scheduling, and online booking options for a smooth and safe journey."
    },
    {
      "name": "Pune to Goa Innova Cab",
      "description": "Hire a spacious and premium Innova cab from Pune to Goa. Ideal for family trips or group outings. Offers AC and Non-AC options, professional drivers, luggage assistance, flexible pickup/drop points, and online booking for a comfortable ride."
    },
    {
      "name": "Pune to Goa Ertiga Cab",
      "description": "Rent an Ertiga cab from Pune to Goa for 7-seater comfort. Perfect for small groups or family travel. Includes AC/Non-AC options, professional chauffeurs, luggage support, timely pickups, online booking, and transparent fares."
    },
    {
      "name": "Luxury Cab Pune to Goa",
      "description": "Premium luxury cab service from Pune to Goa with spacious and comfortable vehicles. Enjoy professional drivers, AC service, luggage assistance, flexible schedules, and online booking for a safe, elegant, and stress-free journey."
    },
    {
      "name": "Affordable Pune to Goa Cab",
      "description": "Budget-friendly cab service from Pune to Goa with AC and Non-AC vehicles. Ideal for families, groups, or solo travelers seeking comfortable and safe travel at affordable prices. Online booking and professional drivers included."
    },
    {
      "name": "Pune to Goa Outstation Cab",
      "description": "Convenient outstation cab service from Pune to Goa. Includes AC/Non-AC vehicles, professional drivers, luggage support, online booking, flexible pickup/drop locations, transparent fares, and 24x7 availability for a hassle-free journey."
    },
    {
      "name": "Pune to Goa One Way Cab",
      "description": "One-way cab service from Pune to Goa for travelers seeking convenience and flexibility. AC and Non-AC options, Innova or Ertiga vehicles, professional drivers, luggage support, online booking, and transparent pricing for a smooth trip."
    },
    {
      "name": "Pune to Goa Drop Cab",
      "description": "Safe and comfortable drop cab service from Pune to Goa. Includes AC/Non-AC vehicles, professional drivers, luggage assistance, flexible pickup/drop locations, online booking, and transparent fares for hassle-free travel."
    },
    {
      "name": "Pune to Goa Corporate Cab",
      "description": "Corporate cab service from Pune to Goa with AC and Non-AC vehicles, professional drivers, luggage support, flexible schedules, online booking, and transparent fares. Ideal for business trips, client meetings, or group corporate travel."
    },
    {
      "name": "Pune to Goa Wedding Cab",
      "description": "Spacious and luxury cab service from Pune to Goa for weddings. AC and Non-AC options, professional drivers, luggage assistance, flexible pickup/drop points, online booking, and transparent fares for comfortable travel of wedding guests."
    },
    {
      "name": "Pune to Goa Online Booking",
      "description": "Instant online cab booking from Pune to Goa with secure payment options. Choose from AC, Non-AC, Innova, Ertiga, or luxury vehicles. Professional drivers, luggage support, flexible pickup/drop points, transparent fares, and 24x7 service ensure seamless travel."
    }
  ],
  "tableData": [
    ["Pune to Goa Cab", "Pune to Goa Taxi Service"],
    ["Pune to Goa Car Hire", "Pune to Goa AC Cab"],
    ["Pune to Goa Non AC Cab", "Pune to Goa Innova Cab"],
    ["Pune to Goa Ertiga Cab", "Luxury Cab Pune to Goa"],
    ["Affordable Pune to Goa Cab", "Pune to Goa Outstation Cab"],
    ["Pune to Goa One Way Cab", "Pune to Goa Drop Cab"],
    ["Pune to Goa Corporate Cab", "Pune to Goa Wedding Cab"],
    ["Pune to Goa Online Booking", ""]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Pune to Goa Cab Service",
    "WhyChoosedescription": "Sai Trupti Cabs  provides reliable and comfortable cab services from Pune to Goa — perfect for leisure trips, weekend getaways, and family vacations."
  },
  {
    "WhyChooseheading": "Transparent & Competitive Fare",
    "WhyChoosedescription": "Enjoy clear and affordable one-way fares from Pune to Goa, with no hidden charges, ensuring a stress-free and cost-effective journey."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicle Options",
    "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs, Ertiga, Innova Crysta, or Tempo Travellers to match your group size, luggage, and comfort preferences for the Pune to Goa route."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our courteous and trained drivers ensure a safe, smooth, and timely journey on the Pune–Goa route."
  },
  {
    "WhyChooseheading": "Flexible Pickup & Drop Locations",
    "WhyChoosedescription": "We provide pickups from any location in Pune and drop-offs at your preferred destination in Goa, including hotels, resorts, or the airport."
  },
  {
    "WhyChooseheading": "Clean & Well-Maintained Vehicles",
    "WhyChoosedescription": "All vehicles are regularly serviced, sanitized, and maintained to guarantee comfort, safety, and reliability for the long drive from Pune to Goa."
  },
  {
    "WhyChooseheading": "24/7 Booking & Customer Support",
    "WhyChoosedescription": "Our dedicated support team is available around the clock to assist with bookings, travel planning, or any queries during your Pune to Goa trip."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Book your Pune to Goa cab easily via call, WhatsApp, or our website — with instant confirmation and prompt vehicle dispatch."
  }
]

























  }

const faqData = [
  {
    question: 'Does Sai Trupti Cabs  offer Pune to Goa cab services?',
    answer: 'Yes, Sai Trupti Cabs  provides reliable and affordable Pune to Goa cab services for one-way trips, round trips, and group travel.',
  },
  {
    question: 'How can I book a Pune to Goa cab with Sai Trupti Cabs?',
    answer: 'You can easily book your Pune to Goa cab through our website, mobile app, or by contacting our 24×7 customer support team for instant confirmation.',
  },
  {
    question: 'What types of cabs are available from Pune to Goa?',
    answer: 'We offer a wide range of vehicles including hatchbacks, sedans, SUVs, Ertiga, Innova Crysta, Urbania, and Tempo Travellers to suit your travel needs, group size, and budget.',
  },
  {
    question: 'Are the drivers experienced for Pune to Goa trips?',
    answer: 'Yes, all our drivers are professional, courteous, and trained for long-distance travel, ensuring a safe and comfortable journey from Pune to Goa.',
  },
  {
    question: 'Can I hire a cab from Pune to Goa for family, corporate, or group travel?',
    answer: 'Certainly. Our cab services cater to family trips, group tours, corporate travel, and sightseeing journeys between Pune and Goa.',
  },
  {
    question: 'Is the Pune to Goa cab service available 24×7?',
    answer: 'Yes, Sai Trupti Cabs offers 24×7 cab services for Pune to Goa trips to fit your schedule and travel plans.',
  },
  {
    question: 'What are the fares for Pune to Goa cab services?',
    answer: 'Cab fares from Pune to Goa start from approximately ₹4,000 for sedans and ₹5,500–₹8,000 for SUVs and larger vehicles, depending on vehicle type, distance, and travel requirements.',
  },
  {
    question: 'What payment methods are accepted for Pune to Goa cab bookings?',
    answer: 'We accept payments via UPI, credit/debit cards, bank transfers, and digital wallets for secure and hassle-free transactions.',
  },
  {
    question: 'What safety and hygiene protocols are followed for Pune to Goa cabs?',
    answer: 'All vehicles are sanitized before every trip, and our drivers follow strict hygiene and safety measures to ensure a secure journey.',
  },
  {
    question: 'Is customer support available during Pune to Goa cab trips?',
    answer: 'Yes, our dedicated 24×7 customer support team is available to assist you before, during, and after your Pune to Goa cab journey.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Amit Kulkarni',
    feedback: 'I booked a cab from Pune to Goa with Sai Trupti Cabs. The ride was comfortable, and the driver was very professional and punctual.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Shweta Deshmukh',
    feedback: 'Sai Trupti Cabs made our Pune to Goa trip smooth and hassle-free. Highly recommend their long-distance cab service.',
    rating: 5,
  },
];











































  const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
  { place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
  { place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
  { place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
  { place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
  { place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
  { place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
  { place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cab", link: "Hinjewadi-to-Mumbai-Cab" },
  { place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cab", link: "Wakad-to-Mumbai-Cab" },
  { place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cab", link: "Hadapsar-to-Mumbai-Cab" },
  { place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
  { place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cab", link: "Koregaon-Park-to-Mumbai-Cab" },
  { place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cab", link: "Kothrud-to-Mumbai-Cab" },
  { place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cab", link: "Kharadi-to-Mumbai-Cab" },
  { place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cab", link: "Shivajinagar-to-Mumbai-Cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cab", link: "Pune-to-Mumbai-Innova-Crysta-Cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
  { place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cab", link: "Kondhwa-to-Mumbai-Cab" },
  { place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
  { place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Goa Cab Service",
  "image": "https://saitrupticabs.com/assets/images/pune-to-goa-cab.jpg",
  "description": "Sai Trupti Cabs offers Pune to Goa cab service with one way taxi, round trip cabs, Innova Crysta, Ertiga, sedan and SUV options. Book affordable outstation cabs for Goa trips with professional drivers, 24x7 service and safe journey experience.",
  "brand": {
    "@type": "Brand",
    "name": "Sai Trupti Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "8125"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3999",
    "availability": "https://schema.org/InStock",
    "url": "https://saitrupticabs.com/pune-to-goa-cab",
    "itemCondition": "https://schema.org/NewCondition"
  }
};








  return (
    <div>
   <Helmet>
  <title>Pune to Goa Cab Service | One Way Taxi ₹3999 | Sai Trupti Cabs</title>

  <meta 
    name="description" 
    content="Book Pune to Goa cab at best price ₹3999 with Sai Trupti Cabs. One way taxi, round trip, Innova Crysta, Ertiga, sedan & SUV available. Safe, affordable and 24x7 cab service for Goa trips." 
  />

  <meta 
    name="keywords" 
    content="pune to goa cab, pune to goa taxi, pune to goa cab service, pune to goa one way cab, pune to goa taxi fare, pune to goa innova crysta, pune to goa ertiga cab, pune to goa sedan cab, cheap pune to goa cab, best cab service pune to goa, pune to goa drop taxi, pune to goa round trip cab, outstation cab pune to goa, pune to goa online cab booking" 
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

<section
      className="breadcrumb-section"
      style={{ backgroundImage: "url(/images/background/inner-banner-bg.png)" }}
    >
      <div className="container">
        <div className="banner-content">
          <h1> {cardData.keyword}</h1>
        </div>
      </div>
    </section>



      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/52.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sai Trupti Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Trupti Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918390907004" className="pc-call">+91 8390907004</a>
                      <a href="tel:+919922727744" className="pc-call">+91 9922727744</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918390907004"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918390907004" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@saitrupticabs.com" className="pc-email">
                      booking@saitrupticabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sai Trupti Cabs </strong><br />
                      Yashoda splendid Park,
                      Office number D. Wing Dudulgaon Anandi,
                        ruial Sainath Chowk Alandi-412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetogoacabs;